import { render } from "./sales-salon.vue?vue&type=template&id=d52568f0&scoped=true&ts=true"
import script from "./sales-salon.vue?vue&type=script&lang=ts"
export * from "./sales-salon.vue?vue&type=script&lang=ts"

import "./sales-salon.vue?vue&type=style&index=0&id=d52568f0&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52568f0"]])

export default __exports__